<brightside-web-survey-main
  [externalControl]="true"
  [displayBackButton]="false"
  (surveyStatus)="onSurveyStatus($event)">
</brightside-web-survey-main>
